import AssetValueCostComparisonStep from './AssetValueCostComparisonStep'

export default AssetValueCostComparisonStep
